"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgFilePdf24 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M0 .5h24v24H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M17.625 9.5H13.5V5.375m4.125 4.177v10.073H6V5.375h7.508l4.117 4.177h0zm-6.22 5.248c.62-1.73.946-3.602 0-3.422-.948.18-.265 1.904.443 3.062s2.054 2.456 2.627 1.702-.935-1.178-2.738-1.07c-1.802.11-3.083 1.281-2.495 1.722.589.44 1.54-.264 2.162-1.994z", strokeLinecap: "square", stroke: "currentColor" })] })) }))); };
exports.default = SvgFilePdf24;
